var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEmptyPlaceList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 110,
    viewBox: "0 0 111 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5632_14109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1735 87.434H98.0317C98.4443 87.434 98.84 87.2684 99.1318 86.9738C99.4235 86.6791 99.5874 86.2794 99.5874 85.8627V27.586C99.5874 27.1692 99.4235 26.7696 99.1318 26.4749C98.84 26.1802 98.4443 26.0146 98.0317 26.0146H45.4346V33.6547",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1735 87.434H98.0317C98.4443 87.434 98.84 87.2684 99.1318 86.9738C99.4235 86.6791 99.5874 86.2794 99.5874 85.8627V27.586C99.5874 27.1692 99.4235 26.7696 99.1318 26.4749C98.84 26.1802 98.4443 26.0146 98.0317 26.0146H45.4346V33.6547",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4346 26.0203L77.1735 33.6603",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1821 33.6592H12.9738C12.7685 33.6576 12.5649 33.6971 12.3747 33.7753C12.1846 33.8536 12.0117 33.9691 11.8659 34.1151C11.7202 34.2612 11.6045 34.435 11.5256 34.6264C11.4466 34.8178 11.406 35.0232 11.406 35.2306V93.5072C11.406 93.924 11.5699 94.3237 11.8617 94.6183C12.1534 94.913 12.5491 95.0786 12.9617 95.0786H75.6119C76.0245 95.0786 76.4202 94.913 76.7119 94.6183C77.0037 94.3237 77.1676 93.924 77.1676 93.5072V33.6592H14.1821Z",
    fill: "white",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.859 64.8457C43.6628 65.8955 41.2541 66.4395 38.8143 66.4368H36.5189C32.2172 66.4384 28.0923 68.1275 25.0514 71.1325C22.0104 74.1375 20.3024 78.2124 20.303 82.4611V95.1094",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4109 33.6924C55.5701 34.0669 55.5701 42.3901 55.5317 50.6122C55.5246 53.7758 54.3062 56.8682 52.0278 59.5056",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2341 35.4724L76.7025 84.4285",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7092 43.4834L75.8214 95.1098",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7092 78.1982L31.7592 78.1982",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9277 78.1982L45.8589 78.1982",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1465 78.1982L58.1964 78.1982",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4905 78.1982L19.4217 78.1982",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1459 28.3421C37.1459 29.2467 36.9299 30.2399 36.5614 31.2895C34.1191 38.1881 24.8485 47.3308 24.8485 47.3308C24.8485 47.3308 15.5793 38.1881 13.137 31.2895C12.7655 30.2399 12.551 29.2467 12.551 28.3421C12.551 25.0478 13.8466 21.8884 16.1529 19.559C18.4591 17.2296 21.587 15.9209 24.8485 15.9209C28.11 15.9209 31.2379 17.2296 33.5441 19.559C35.8503 21.8884 37.1459 25.0478 37.1459 28.3421Z",
    fill: "#EDEDED",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8484 34.1984C23.7022 34.1984 22.5817 33.8551 21.6287 33.2119C20.6757 32.5687 19.9329 31.6545 19.4942 30.5849C19.0556 29.5153 18.9408 28.3383 19.1645 27.2028C19.3881 26.0673 19.94 25.0243 20.7505 24.2057C21.561 23.3871 22.5936 22.8296 23.7178 22.6037C24.842 22.3778 26.0072 22.4937 27.0662 22.9368C28.1251 23.3798 29.0302 24.1301 29.667 25.0927C30.3038 26.0553 30.6437 27.1871 30.6437 28.3448C30.6421 29.8968 30.031 31.3847 28.9445 32.4822C27.858 33.5796 26.3849 34.1968 24.8484 34.1984Z",
    fill: "white",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6529 55.4489C81.6308 56.194 81.4842 56.9301 81.2194 57.6259C79.416 62.7213 72.568 69.475 72.568 69.475C72.568 69.475 65.72 62.7213 63.9166 57.6259C63.6529 56.9298 63.5069 56.1939 63.4846 55.4489C63.4691 54.234 63.6926 53.0281 64.1422 51.9011C64.5918 50.7742 65.2584 49.7486 66.1035 48.8839C66.9486 48.0193 67.9553 47.3327 69.0651 46.8642C70.1749 46.3956 71.3659 46.1543 72.5688 46.1543C73.7717 46.1543 74.9626 46.3956 76.0724 46.8642C77.1823 47.3327 78.189 48.0193 79.034 48.8839C79.8791 49.7486 80.5458 50.7742 80.9953 51.9011C81.4449 53.0281 81.6684 54.234 81.6529 55.4489Z",
    fill: "#EDEDED",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.5681 59.7742C71.7211 59.7745 70.8931 59.5211 70.1888 59.0461C69.4844 58.571 68.9354 57.8957 68.611 57.1054C68.2867 56.3151 68.2017 55.4455 68.3668 54.6064C68.5318 53.7674 68.9395 52.9966 69.5383 52.3916C70.1371 51.7866 70.9 51.3745 71.7307 51.2075C72.5613 51.0405 73.4223 51.126 74.2048 51.4533C74.9873 51.7806 75.6562 52.335 76.1267 53.0463C76.5973 53.7575 76.8485 54.5938 76.8485 55.4493C76.8473 56.5957 76.396 57.6948 75.5935 58.5056C74.7911 59.3164 73.7031 59.7726 72.5681 59.7742Z",
    fill: "white",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7527 25.1843C95.7306 25.9294 95.5841 26.6654 95.3193 27.3612C93.5159 32.4566 86.6679 39.2103 86.6679 39.2103C86.6679 39.2103 79.8198 32.4566 78.0165 27.3612C77.7528 26.6651 77.6068 25.9292 77.5845 25.1843C77.569 23.9693 77.7925 22.7634 78.2421 21.6365C78.6916 20.5095 79.3583 19.4839 80.2034 18.6193C81.0484 17.7546 82.0551 17.0681 83.165 16.5995C84.2748 16.1309 85.4657 15.8896 86.6686 15.8896C87.8715 15.8896 89.0624 16.1309 90.1723 16.5995C91.2821 17.0681 92.2888 17.7546 93.1339 18.6193C93.979 19.4839 94.6456 20.5095 95.0952 21.6365C95.5447 22.7634 95.7683 23.9693 95.7527 25.1843Z",
    fill: "#EDEDED",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6679 29.5103C85.821 29.5106 84.993 29.2572 84.2886 28.7822C83.5843 28.3071 83.0352 27.6318 82.7109 26.8415C82.3866 26.0512 82.3016 25.1816 82.4666 24.3425C82.6317 23.5034 83.0394 22.7327 83.6381 22.1277C84.2369 21.5226 84.9999 21.1106 85.8305 20.9436C86.6612 20.7766 87.5222 20.8621 88.3047 21.1894C89.0872 21.5167 89.756 22.0711 90.2266 22.7823C90.6972 23.4936 90.9483 24.3299 90.9483 25.1853C90.9471 26.3318 90.4958 27.4309 89.6934 28.2417C88.891 29.0525 87.8029 29.5087 86.6679 29.5103Z",
    fill: "white",
    stroke: "#C2C2C2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5632_14109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 81,
    fill: "white",
    transform: "translate(10.5 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyPlaceList);
export default __webpack_public_path__ + "static/media/icon-empty-place-list.2a9ae7e5cb71384ac496239b58407ed5.svg";
export { ForwardRef as ReactComponent };